exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fade-enter-active[data-v-65290de0],\n.fade-leave-active[data-v-65290de0] {\n\ttransition: opacity 0.5s;\n}\n.fade-enter[data-v-65290de0],\n.fade-leave-to[data-v-65290de0] {\n\topacity: 0;\n}\n", ""]);

// exports
